import React from 'react';
import { styled } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ImageWrapper = styled.button((props) => `
  border-radius: 4px;
  position: relative;
  border: 1px solid ${props.active ? props.theme.brand.primary : "transparent"};
  width: 50px;
  margin-right: .5rem;
  padding: .2rem;
  background-color: transparent;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  `);
const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: calc(100% - 10px);
`;
const Extra = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const SmallImage = ({
  image,
  active,
  onMouseEnter,
  onClick,
  extra
}) => {
  return /* @__PURE__ */ React.createElement(ImageWrapper, {
    active,
    onMouseEnter,
    onClick
  }, /* @__PURE__ */ React.createElement(Image, __spreadValues({}, image)), extra && /* @__PURE__ */ React.createElement(Extra, null, extra));
};

export { SmallImage };
